import { Routes } from '@angular/router';
// import { authGuard } from './guards/auth/auth.guard';
// import { authGuard } from './guards/auth/auth.guard';
// import { notAuthGuard } from './guards/not-auth/not-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.component').then((m) => m.LandingComponent),
    data: {
      title: 'PawPrint AI - Ветеринарный ИИ для заботы о вашем питомце',
      description: 'PawPrint — AI-ассистент для владельцев домашних животных. Задайте вопрос о здоровье, питании и уходе за питомцем и получите мгновенный совет. Кошки, собаки, кролики и другие питомцы — 24/7.',
      canonical: 'https://pawprint.kz'
    }
  },
  {
    path: 'chat',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    data: {
      title: 'PawPrint AI - Ветеринарный ИИ для заботы о вашем питомце',
      description: 'PawPrint — AI-ассистент для владельцев домашних животных. Задайте вопрос о здоровье, питании и уходе за питомцем и получите мгновенный совет. Кошки, собаки, кролики и другие питомцы — 24/7.',
      canonical: 'https://pawprint.kz/chat'
    }
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
    data: {
      title: 'PawPrint AI - Политика конфиденциальности',
      description: 'Узнайте, как PawPrint защищает вашу личную информацию и данные о ваших питомцах.',
      canonical: 'https://pawprint.kz/privacy-policy'
    }
  },
  {
    path: 'termsofuse',
    loadComponent: () => import('./pages/termsofuse/termsofuse.component').then((m) => m.TermsOfUseComponent),
    data: {
      title: 'PawPrint AI - Условия использования',
      description: 'Узнайте, как использовать PawPrint и какие правила действуют при взаимодействии с нашим сервисом.',
      canonical: 'https://pawprint.kz/termsofuse'
    }
  },
  {
    path: '**',
    redirectTo: '',
  }
];

// export const routes: Routes = [
//   { path: '', pathMatch: 'full', redirectTo: '/welcome' },
//   { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.routes').then(m => m.WELCOME_ROUTES) }
// ];
